import { getBaseUrl, request } from 'src/helpers/api';

export const submitResidentAvailabilities = (
  tenantAccessCode: string,
  params: {
    resident_availability: Array<{ date: string, timings?: string[] }>,
    tenant_code?:string
  },
) => request({
  method: 'POST',
  url: `${getBaseUrl()}resident-availability/${tenantAccessCode}`,
  contentType: 'json',
  includeToken: true,
  params,
});

export const fetchResidentAvailabilities = (
  tenantAccessCode: string,
  params: { tenant_code: string } | {},
) => request({
  method: 'GET',
  url: `${getBaseUrl()}resident-availability/${tenantAccessCode}`,
  includeToken: true,
  params,
});

export const getResidentAvailabilitiesForesight = (woAccessCode:string) => request({
  method: 'GET',
  url: `${getBaseUrl()}api/public/resident-availability/${woAccessCode}`,
});

export const submitResidentAvailabilitiesForesight = (
  woAccessCode:string,
  params: { resident_availability: Array<{ date: string, timings?: string[] }> },
) => request({
  method: 'POST',
  url: `${getBaseUrl()}api/public/resident-availability/${woAccessCode}`,
  contentType: 'json',
  params,
});
